<template>
  <base-section id="soutenir-section" space="36">
    <v-container>
      <!-- <v-row justify="center">
        <v-col cols="12">
          <base-section-heading
            title="Soutenez le Fonds pour l'independance de la presse"
            text="Votre contribution est essentielle pour défendre l'indépendance de la presse, le pluralisme et la liberté d'information. Vous pouvez faire votre don directement via le formulaire sécurisé HelloAsso ci-dessous."
          />
        </v-col>
      </v-row> -->

      <v-row justify="center" class="mt-4">
        <v-col cols="12" md="10" lg="9">
          <v-card
            elevation="4"
            class="overflow-hidden rounded-lg mx-auto"
            style="position: relative; min-height: 800px; border: 1px solid rgba(0,0,0,0.08);"
          >
            <!-- Loader standard -->
            <v-fade-transition>
              <div
                v-if="loading"
                class="d-flex flex-column align-center justify-center"
                style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: #fafafa; z-index: 2;"
              >
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="64"
                  width="4"
                ></v-progress-circular>
                <div class="mt-4 grey--text text--darken-1 font-weight-medium">
                  Chargement du formulaire de don sécurisé...
                </div>
              </div>
            </v-fade-transition>

            <!-- Iframe HelloAsso -->
            <iframe
              :src="soutenirUrl"
              style="width: 100%; height: 950px; border: none; display: block;"
              allow="payment"
              id="helloasso-iframe"
              @load="loading = false"
            ></iframe>
          </v-card>

          <!-- Fallback Option -->
          <div class="text-center mt-6">
            <p class="grey--text text--darken-1 body-2">
              Un problème avec l'affichage du formulaire ? Vous pouvez également y accéder directement :
            </p>
            <v-btn
              :href="soutenirUrl"
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
              outlined
              class="font-weight-bold px-6"
            >
              <v-icon left>mdi-open-in-new</v-icon>
              Ouvrir le formulaire sur HelloAsso
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionSoutenir',

    data: () => ({
      loading: true,
      soutenirUrl: process.env.VUE_APP_SOUTENIR_URL || 'https://www.helloasso.com/associations/fonds-pour-une-presse-libre/formulaires/1/widget',
    }),
  }
</script>
